import { callable, buildHtmlContext, buildHtmlOptions, iterable, mix, observable, ownEffect, createBasicRenderer, watch } from "@chorda/core";
import { App, routes } from "./App";
import { useRouter } from "./router";
export const createAppScope = () => {
    //     const engine = createAsyncPatcher()
    //     const renderer = createReactRenderer()
    //     engine.subscribe(renderer)
    //     //engine.chain(renderer)
    //     const scope : HtmlScope&AppScope = {
    //         $renderer: renderer,
    //         $engine: engine,
    //         $pipe: pipe(engine, renderer),
    //         $defaultFactory: defaultHtmlFactory,
    //         $defaultLayout: defaultLayout,
    // //        $vnodeFactory: defaultVNodeFactory,
    //         router: null
    //     }
    const context = Object.assign({ router: null }, buildHtmlContext(createBasicRenderer()));
    useRouter(context, (router) => {
        router.setOption('defaultRoute', 'home');
        router.add(routes);
    });
    return context;
};
export const createAppOptions = () => {
    return buildHtmlOptions(App());
};
let _HTML = null;
export const render = (html, el) => {
    _HTML = html; // FIXME
    document.addEventListener('DOMContentLoaded', () => {
        html.attach(el());
    });
};
export const Coerced = (props) => {
    return mix(props.as, props, {
        templates: {
            content: props.content
        }
    });
};
export const Custom = (props) => {
    return mix(props.as, props, {
        templates: {
            content: props.content
        }
    });
};
export const Content = Custom;
export const withHtml = (props) => {
    return props;
};
// export const withScope = <S, E=unknown, T=unknown>(props: CustomProps<Omit<T, keyof S>&S, E&DomEvents&HtmlEvents>) : InferBlueprint<T, E> => {
//     return mix(props.as, props)
// }
export const withBlueprint = (props) => {
    return mix(props.as, props);
};
export const withAs = withBlueprint;
export const withHtmlBlueprint = (props) => {
    return mix(props.as, props);
};
//export const withScope = <T>
export const buildHtmlTree = () => {
    const nodes = [];
    const edges = [];
    let c = 1;
    let cid = 1;
    const ids = new Map();
    visitHtml((node, parent, level, cluster) => {
        const id = c++;
        ids.set(node, id);
        if (node.items.length > 20 && cluster == null) {
            cluster = cid++;
        }
        const n = { id, level, cid: cluster, color: cluster ? 'red' : null, label: (node.key || node.index) };
        nodes.push(n);
        if (parent) {
            edges.push({
                id: c++,
                from: ids.get(parent),
                to: id
            });
        }
        return cluster;
    });
    return {
        nodes,
        edges
    };
};
const visitHtml = (f, node = _HTML, level = 1, cluster) => {
    if (node == _HTML) {
        cluster = f(node, null, level, cluster);
    }
    node.children.forEach(child => {
        const c = f(child, node, level + 1, cluster);
        !c && visitHtml(f, child, level + 1, c);
    });
};
export const createValueEffect = (bus, name, effect) => {
    const start = bus.$event(name + 'Start');
    const done = bus.$event(name + 'Done');
    const f = (...args) => {
        start();
        return effect
            .apply(this, args)
            .then((value) => {
            bus.$value = value;
            done(value);
            return value;
        });
    };
    return f;
};
export const DynamicList = (props) => {
    return mix({
        reactions: {
            __it: (v) => ({ items: v }),
        },
        injections: {
            __it: (scope) => {
                //                console.log('__it', scope.items)
                return iterable(scope.items, '__item');
            }
        },
        defaultItem: Coerced({
            injections: {
                item: (scope) => {
                    //                    console.log('item', scope.$context.__it)
                    return scope.__item;
                }
            }
        })
    }, props === null || props === void 0 ? void 0 : props.as, 
    //    ...props?.with,
    props && {
        injections: {
            items: props.items$
        },
        defaultItem: props.defaultItem
    });
};
export const withIterableItems = (props) => {
    return mix({
        reactions: {
            __it: (v) => ({ items: v }),
        },
        injections: {
            __it: (scope) => {
                return iterable(scope.items, '__item');
            }
        },
        defaultItem: mix({
            injections: {
                item: (scope) => scope.__item
            }
        })
    }, props === null || props === void 0 ? void 0 : props.as, props);
};
export const withItem = (props) => {
    return mix(props);
};
export const withList = (props) => {
    return mix(props, {
        injections: {
            $items: ($) => iterable($.items, '$item')
        },
        reactions: {
            $items: (v) => ({ items: v })
        },
        defaultItem: {
            injections: {
                item: ($) => $.$item
            }
        }
    });
};
export const onOuterClick = ({ $dom }) => {
    $dom.$event('outerClick');
    const listener = () => {
        $dom.$emit('outerClick');
    };
    document.addEventListener('mousedown', listener);
    return () => {
        document.removeEventListener('mousedown', listener);
    };
};
export const withOuterClick = (props) => {
    return mix({
        defaults: {
            onOuterClick: () => callable(null)
        },
        joints: {
            initOuterClick: ({ onOuterClick }) => {
                // const listener = () => {
                //     onOuterClick()
                // }
                document.addEventListener('mousedown', onOuterClick);
                return () => {
                    document.removeEventListener('mousedown', onOuterClick);
                };
            }
        }
    }, props);
};
export const withStopMouseDown = (props, preventDefault) => {
    return mix({
        joints: {
            initStopMouseDown: ({ $dom }) => {
                $dom.$subscribe((el) => {
                    el === null || el === void 0 ? void 0 : el.addEventListener('mousedown', (e) => {
                        e.stopPropagation();
                        preventDefault && e.preventDefault(); // если поставить, то будет слетать фокус на input
                        return false;
                    });
                });
            }
        }
    }, props);
};
export const withPreventDefaultMouseDown = (props) => {
    return withStopMouseDown(props, true);
};
export const stopMouseDown = ({ $dom }) => {
    $dom.$subscribe((el) => {
        el === null || el === void 0 ? void 0 : el.addEventListener('mousedown', (e) => {
            e.stopPropagation();
            //e.preventDefault()
            return false;
        });
    });
};
export const autoFocus = ({ $dom, $renderer }) => {
    $dom.$subscribe(el => {
        if (el) {
            $renderer.queue(ownEffect(() => {
                el.focus();
            }));
        }
    });
};
export const withBounds = (props) => {
    return mix({
        defaults: {
            bounds: () => observable(null),
        },
        joints: {
            updateBounds: ({ $dom, bounds }) => {
                watch(() => {
                    if ($dom.$value) {
                        bounds.$value = $dom.$value.getBoundingClientRect();
                    }
                }, [$dom]);
            }
        }
    }, props);
};
export const withMix = (...args) => {
    return mix.apply(this, args);
};
export const withOuterKeydown = (props) => {
    return mix({
        defaults: {
            onOuterKeyDown: () => callable(null)
        },
        joints: {
            initGlobalKeyDown: ({ onOuterKeyDown }) => {
                document.addEventListener('keydown', onOuterKeyDown);
                return () => {
                    document.removeEventListener('keydown', onOuterKeyDown);
                };
            }
        }
    }, props);
};
// export const debounced = <T extends () => void>(timeout: number, fn: T) : any => {
//     let t : any = null
//     return () => {
//         if (t) {
//             clearTimeout(t)
//         }
//         t = setTimeout(() => {
//             t = null
//             fn()
//         }, timeout)
//     }
// }
